import React, { useState } from 'react'
// import bannerCabecera from '../../imagenes/sobrePedraza/bg-sobre-pedraza.jpg'
// import bannerCabecera2x from '../../imagenes/sobrePedraza/bg-sobre-pedraza@2x.jpg'
//import galicia from "../../imagenes/checkout/payment-options/galicia.png";
//import santander from "../../imagenes/checkout/payment-options/santander.png";
// import patagonia from '../../imagenes/checkout/payment-options/patagonia.png'
//import provincia from "../../imagenes/checkout/payment-options/provincia.png";
import { Link } from "react-router-dom";
import naranja from '../../imagenes/checkout/payment-options/ico-tarjeta_0001_naranja.png'
import cabal from '../../imagenes/checkout/payment-options/ico-tarjeta_0000_cabal.jpg'
import visa from '../../imagenes/checkout/payment-options/ico-tarjeta_0004_visa.jpg'
import master from '../../imagenes/checkout/payment-options/ico-tarjeta_0003_master.jpg'
import american from '../../imagenes/checkout/payment-options/ico-tarjeta_0002_american.jpg'
import { RUTA_IMAGEN } from '../../utils/rutasFijas'

const FormasDePago = () => {
  const [mostrarModal, setMostrarModal] = useState(false);
  const [urlImagen, setUrlImagen] = useState('');
  //detalleVisa.png
  
  const handleClickTarjeta = (nombreUrl) => {
    setUrlImagen(`${RUTA_IMAGEN}bancos/${nombreUrl}`);
    setMostrarModal(true);
  }

  return (
    <section className="sobre-pedraza">
      <div className="container">
        <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <article className="txt formaDePago col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h1>Como pagar en Pedraza Viajes y Turismo</h1>
            <p style={{fontSize: '1.2rem', padding: '1em 0'}}>
              En Pedraza Viajes y Turismo podés comprar de manera segura con
              Tarjeta de Crédito y/o Débito, Depósito o Transferencia Bancaria o en
              Efectivo en nuestras sucursales.
            </p>
            <hr />

            <div className="divFormaDePago">
              <h3>Pagá con Tarjeta de Crédito en cuotas</h3>
              <div className="nuevoContenedorPromosBancarias">
                <div
                  className="cuadroTarjeta"
                  onClick={() => handleClickTarjeta("detalle-cabal")}
                >
                  <img src={cabal} alt="Cabal" />

                  <p className="textoCuota">Hasta 6 cuotas fijas</p>
                  <p className="textoCondiciones">
                    Consulta condiciones vigentes
                  </p>
                </div>

                <div
                  className="cuadroTarjeta"
                  onClick={() => handleClickTarjeta("detalle-visa")}
                >
                  <img src={visa} alt="Visa" />

                  <p className="textoCuota">Hasta 6 cuotas fijas</p>
                  <p className="textoCondiciones">
                    Consulta condiciones vigentes
                  </p>
                </div>

                <div
                  className="cuadroTarjeta"
                  onClick={() => handleClickTarjeta("detalle-american")}
                >
                  <img src={american} alt="American Express" />

                  <p className="textoCuota">Hasta 6 cuotas fijas</p>
                  <p className="textoCondiciones">
                    Consulta condiciones vigentes
                  </p>
                </div>

                <div
                  className="cuadroTarjeta"
                  onClick={() => handleClickTarjeta("detalle-master")}
                >
                  <img src={master} alt="Mastercad" />

                  <p className="textoCuota">Hasta 6 cuotas fijas</p>
                  <p className="textoCondiciones">
                    Consulta condiciones vigentes
                  </p>
                </div>

                <div
                  className="cuadroTarjeta"
                  onClick={() => handleClickTarjeta("detalle-naranja")}
                >
                  <img src={naranja} alt="Tarjeta Naranja" />

                  <p className="textoCuota">Plan Z</p>
                  <p className="textoCondiciones">
                    Consulta condiciones vigentes
                  </p>
                </div>
              </div>
            </div>

            <div className="divFormaDePago divFormaDePagoMedio">
              <h3>Pagá con Depósito o Transferencia Bancaria</h3>
              <p style={{fontSize: '1.2rem', padding: '1em 0'}}>
                Una vez elegida tu compra, seleccioná la modalidad Depósito o
                Transferencia. Podés pagar en nuestra siguiente cuenta bancaria:
              </p>
               <div className="nuevoContenedorPromosBancarias">
                 <img
                          src={`${RUTA_IMAGEN}bancos/detalle-cuenta-galicia.jpeg`}
                          srcSet={`${RUTA_IMAGEN}bancos/detalle-cuenta-galicia.jpeg 1200w,
                              ${RUTA_IMAGEN}bancos/detalle-cuenta-galicia.jpeg 163w`}
                          sizes="(max-width: 700px) 500px"
                          alt="Detalle de la tarjeta"
                        />
                        </div>
                         {/*
              <div className="nuevoContenedorPromosBancarias">
                <div
                  className="cuadroTarjeta"
                  onClick={() => handleClickTarjeta("detalle-cuenta-galicia")}
                >
                  <img src={galicia} alt="Galicia" width="200" />

                  <p className="textoCondiciones" style={{paddingTop: '5px'}}>
                    Ver datos bancarios
                  </p>
                </div>
               

              <div
                  className="cuadroTarjeta"
                  onClick={() => handleClickTarjeta("detalle-cuenta-santander")}
                >
                  <img src={santander} alt="Santander" width="200" />

                  <p className="textoCondiciones" style={{paddingTop: '5px'}}>
                    Ver datos bancarios
                  </p>
                </div>

                <div
                  className="cuadroTarjeta"
                  onClick={() => handleClickTarjeta("detalle-cuenta-provincia")}
                >
                  <img src={provincia} alt="Banco Provincia" />

                  <p className="textoCondiciones" style={{paddingTop: '5px'}}>
                    Ver datos bancarios
                  </p>
                </div>

              </div>
      */}
            {/*
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                <div className="depositoFormaDePago col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 d-inline-block">
                  <div>
                    <img src={galicia} alt="Imagen de fondo acerca de viajes" />
                  </div>
                  <p className="textoCuentasFormasDePago">
                    <strong>DEPOSITOS</strong>
                    <br />
                    Por ventanilla o cajeros de autoservicio Cobranzas
                    Integradas Pedraza Viajes Nº 2641
                    <br />
                    CUIT: 30-69687727-7
                  </p>
                  <p className="textoCuentasFormasDePago">
                    <strong>TRANSFERENCIAS</strong>
                    <br />
                    Cuenta Corriente en Pesos Nº 11466/6
                    <br />
                    Sucursal Nº: 339-3
                    <br />
                    CBU Nº: 0070339820000011466633
                    <br />
                    Pedraza Viajes y Turismo S.A.
                    <br />
                    CUIT: 30-69687727-7
                  </p>
                  <p className="textoCuentasFormasDePago">
                    <strong>GALICIA USD</strong>
                    <br />
                    Cuenta Corriente en Dólares Nº 9750 154-4
                    <br />
                    Sucursal Nº: 339-0
                    <br />
                    CBU: 0070339831009750154407
                  </p>
                </div>

                <div className="depositoFormaDePago col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 d-inline-block">
                  <div>
                    <img
                      src={santander}
                      alt="Imagen de fondo acerca de viajes"
                    />
                  </div>
                  <p className="textoCuentasFormasDePago">
                    <strong>DEPOSITOS Y TRANSFERENCIAS</strong>
                    <br />
                    Cuenta Corriente en Pesos Nº 3605/6
                    <br />
                    Sucursal Nº: 087
                    <br />
                    CBU Nº: 0720087820000000360568
                    <br />
                    Pedraza Viajes y Turismo S.A.
                    <br />
                    CUIT: 30-69687727-7
                  </p>
                  <p className="textoCuentasFormasDePago">
                    <strong>SANTANDER RIO USD</strong>
                    <br />
                    Cuenta Corriente en Dólares Nº: 087/013678/7
                    <br />
                    CBU: 0720087821000001367873
                    <br />
                    CUIT: 30-69687727-7
                  </p>
                </div>

                <div className="depositoFormaDePago col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 d-inline-block">
                  <div>
                    <img
                      src={provincia}
                      alt="Imagen de fondo acerca de viajes"
                    />
                  </div>
                  <p className="textoCuentasFormasDePago">
                    <strong>DEPOSITOS Y TRANSFERENCIAS</strong>
                    <br />
                    Cuenta Corriente en Pesos Nº 64309/8
                    <br />
                    CBU Nº: 0140000701100006430986
                    <br />
                    Pedraza Viajes y Turismo S.A.
                    <br />
                    CUIT: 30-69687727-7
                  </p>
                  <p className="textoCuentasFormasDePago">
                    <strong>BANCO PROVINCIA RIO USD</strong>
                    <br />
                    Cuenta Corriente en Dólares Nº: 515484/7
                    <br />
                    CBU: 0140000704100051548479
                    <br />
                    CUIT: 30-69687727-7
                  </p>
                </div>

              </div>
            */}
            </div>

            <div className="divFormaDePago">
              <h3>Pagá en Efectivo</h3>
              <p style={{fontSize: '1.2rem', padding: '1em 0'}}>
                Una vez elegida tu compra, seleccioná la modalidad efectivo y
                acercate a cualquiera de nuestras{" "}
                <Link to="/sucursales">SUCURSALES</Link> para concret&aacute;r
                el pago.{" "}
              </p>
            </div>

            <div
                  className="modal"
                  style={{
                    display: mostrarModal ? "block" : "none",
                    backgroundColor: "#8a8a8a80",
                  }}
                  onClick={() => setMostrarModal(false)}
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalCenterTitle"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered "
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Información</h5>
                        <button
                          type="button"
                          onClick={() => setMostrarModal(false)}
                          style={{
                            color: "#fff",
                            opacity: "1",
                            textShadow: "none",
                          }}
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div
                        className="modal-body"
                        style={{ textAlign: "center" }}
                      >
                        <img
                          src={`${urlImagen}.jpg`}
                          srcSet={`${urlImagen}-mob.jpg 600w,
                              ${urlImagen}.jpg 163w`}
                          sizes="(max-width: 700px) 600px, 163px"
                          alt="Detalle de la tarjeta"
                        />
                      </div>
                    </div>
                  </div>
                </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default FormasDePago;



// WEBPACK FOOTER //
// ./src/components/Global/FormasDePago.js